import * as React from 'react';
import cx from 'classnames';
import styles from './FileUpload.css';
export class FileUpload extends React.Component {
    constructor() {
        super(...arguments);
        this.id = `fk-${Math.random().toString(36).slice(2)}`;
        this.handleImageUpload = (e) => {
            const { files } = e.target;
            if (!files || !files.length)
                return;
            if (typeof this.props.onAddFiles === 'function') {
                this.props.onAddFiles(files);
            }
            e.target.value = ''; // reset the input
        };
    }
    render() {
        const { children, classNames = {}, accepts, multiple } = this.props;
        return (<div className={cx(styles['file-upload'], classNames.wrapper)}>
				<input className={styles['input']} id={this.id} type="file" accept={accepts} multiple={multiple} onChange={this.handleImageUpload}/>
				<label className={classNames.button} htmlFor={this.id}>
					{children}
				</label>
			</div>);
    }
}
FileUpload.defaultProps = {
    classNames: {},
    accepts: 'image/*'
};
